<template>
  <div class="lecturer-resource-container">
    <!-- 主体内容区 - 双栏布局 -->
    <div class="main-content">
      <!-- 左侧讲师资源面板 -->
      <div class="left-panel">
        <!-- 面板标题 -->
        <div class="panel-header">
          <div class="header-icon">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <span class="panel-title">讲师资源</span>
        </div>

        <!-- 功能按钮组 -->
        <div class="function-tabs">
          <div
            class="tab-item"
            :class="{ active: activeTab === 'list' }"
            @click="switchTab('list')"
          >
            <div class="tab-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
              </svg>
            </div>
            <span>讲师名录</span>
          </div>
          <div
            class="tab-item"
            :class="{ active: activeTab === 'schedule' }"
            @click="switchTab('schedule')"
          >
            <div class="tab-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
              </svg>
            </div>
            <span>全员档期</span>
          </div>
          <div
            class="tab-item"
            :class="{ active: activeTab === 'yearView' }"
            @click="switchTab('yearView')"
          >
            <div class="tab-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
              </svg>
            </div>
            <span>全年视图</span>
          </div>
        </div>

        <!-- 搜索框 -->
        <div class="search-box">
          <el-select
            v-model="selectedTeacherClass"
            multiple
            collapse-tags
            placeholder="讲师分类"
            size="small"
            style="width: 150px; margin-right: 10px;"
            @change="handleSearch"
            clearable>
            <el-option
              v-for="item in teacherClassList"
              :key="item.atcId"
              :label="item.atcName"
              :value="item.atcId">
            </el-option>
          </el-select>
          <el-input
            v-model="searchKeyword"
            placeholder="搜索讲师姓名/职位"
            prefix-icon="el-icon-search"
            clearable
           size="small"
            style="width: 200px;"
            @input="handleSearch"
            @clear="handleSearch"
          ></el-input>
        </div>

        <!-- 讲师列表 -->
        <div class="lecturer-list" v-loading="loading">
          <div
            v-for="lecturer in lecturerList"
            :key="lecturer.teacherId"
            class="lecturer-item"
            :class="{ active: currentLecturer && currentLecturer.teacherId === lecturer.teacherId }"
            @click="selectLecturer(lecturer)"
          >
            <!-- 左侧数字编号 -->
            <div class="lecturer-index">{{ lecturer.teacherId }}</div>
            <!-- 头像 -->
            <div class="lecturer-avatar">
              <img
                v-if="lecturer.teacherHeader"
                :src="lecturer.teacherHeader"
                class="avatar-img"
                alt="头像"
              >
              <span v-else class="avatar-text">{{ getAvatarText(lecturer.teacherName) }}</span>
            </div>
            <div class="lecturer-info">
              <div class="lecturer-name">{{ lecturer.teacherName }}</div>
              <div class="lecturer-position">{{ lecturer.teacherPosition || '暂无职位' }}</div>
              <!-- 讲师分类标签 -->
              <div class="lecturer-categories" v-if="lecturer.atcNames">
                <el-tag
                  v-for="(name, index) in getCategoryList(lecturer.atcNames)"
                  :key="index"
                  size="mini"
                  :type="['danger', 'success', 'warning', 'info', 'primary'][index % 5]"
                  effect="plain"
                  class="category-tag"
                >
                  {{ name }}
                </el-tag>
              </div>
            </div>
            <div class="lecturer-type">
              <el-tag size="mini" :type="getTypeTagType(lecturer.teacherType)">
                {{ getTypeLabel(lecturer.teacherType) }}
              </el-tag>
            </div>
          </div>
        </div>

        <!-- 分页组件 -->
        <div class="pagination-wrapper">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            :pager-count="5"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 右侧内容区 - router-view -->
      <div class="right-panel">
        <keep-alive>
          <router-view :teacherId="currentTeacherId" @update-lecturer="handleUpdateLecturer"></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { getAjTeacherListOperation, getAjTeacherClassList } from "../../api/api";

export default {
  name: "LecturerResource",
  data() {
    return {
      searchKeyword: "",
      lecturerList: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      activeTab: "list", // 默认选中讲师名录
      currentLecturer: null,
      currentTeacherId: null,
      // 讲师分类筛选
      teacherClassList: [],
      selectedTeacherClass: []
    };
  },
  created() {
    this.initData();
  },
  methods: {
    // 获取头像文字
    getAvatarText(name) {
      if (!name) return "老师";
      const len = name.length;
      if (len <= 2) return name;
      return name.substring(len - 2);
    },

    // 获取类型标签颜色
    getTypeTagType(type) {
      const typeMap = { 1: '', 2: 'success', 3: 'warning' };
      return typeMap[type] || '';
    },

    // 获取类型标签文本
    getTypeLabel(type) {
      const typeMap = { 1: '内部', 2: '外部', 3: '独家' };
      return typeMap[type] || '未知';
    },

    // 获取分类名称列表
    getCategoryList(atcNames) {
      if (!atcNames) return [];
      return atcNames.split(',').filter(name => name.trim());
    },

    initData() {
      this.getListData();
      this.getTeacherClassList();
    },

    // 获取讲师分类列表
    async getTeacherClassList() {
      try {
        const res = await getAjTeacherClassList();
        if (res.status === 200) {
          this.teacherClassList = res.data || [];
        } else {
          this.$message.error(res.msg || '获取讲师分类失败');
        }
      } catch (error) {
        console.error('获取讲师分类失败:', error);
      }
    },

    // 分页切换
    handlePageChange(page) {
      this.currentPage = page;
      this.getListData();
    },

    // 获取列表数据
    async getListData() {
      this.loading = true;
      try {
        const params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          teacherName: this.searchKeyword
        };
        // 添加讲师分类筛选条件
        if (this.selectedTeacherClass.length > 0) {
          params.atcIds = JSON.stringify(this.selectedTeacherClass);
        }
        const res = await getAjTeacherListOperation(params);
        if (res.status === 200) {
          this.lecturerList = res.data || [];
          this.totalCount = res.total || 0;

          if (this.lecturerList.length > 0 && !this.currentLecturer) {
            this.selectLecturer(this.lecturerList[0]);
          }
        } else {
          this.$message.error(res.msg || '获取讲师列表失败');
        }
      } catch (error) {
        console.error("获取讲师列表失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.getListData();
    },

    // 选择讲师
    selectLecturer(lecturer) {
      this.currentLecturer = lecturer;
      this.currentTeacherId = lecturer.teacherId;
      this.$router.push({
        path: "/Home/lecturerResource/lecturerDetail",
        query: { teacherId: lecturer.teacherId }
      });
    },

    // 切换tab
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'list') {
        this.$router.push({
          path: "/Home/lecturerResource/lecturerDetail",
          query: this.$route.query
        });
      } else if (tab === 'yearView') {
        this.$router.push({
          path: "/Home/lecturerResource/yearView"
        });
      } else if (tab === 'schedule') {
        // 全员档期跳转到月视图
        this.$router.push({
          path: "/Home/lecturerResource/monthView"
        });
      }
    },

    // 更新讲师信息
    handleUpdateLecturer(updatedLecturer) {
      const index = this.lecturerList.findIndex(
        item => item.teacherId === updatedLecturer.teacherId
      );
      if (index !== -1) {
        this.$set(this.lecturerList, index, updatedLecturer);
      }
      if (this.currentLecturer && this.currentLecturer.teacherId === updatedLecturer.teacherId) {
        this.currentLecturer = updatedLecturer;
      }
    }
  }
};
</script>

<style scoped>
.lecturer-resource-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}

/* 主体内容 */
.main-content {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* 左侧面板 */
.left-panel {
  width: 320px;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e4e7ed;
}

.panel-header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  letter-spacing: 1px;
}

/* 功能标签页 */
.function-tabs {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  gap: 8px;
  background: #fafbfc;
}

.tab-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.tab-item:hover {
  background: #f0f5ff;
  border-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.tab-item.active {
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
}

.tab-item.active .tab-icon {
  opacity: 1;
}

/* 搜索框 */
.search-box {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  gap: 0;
}

.search-box ::v-deep .el-input__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.search-box ::v-deep .el-select .el-input__inner {
  border-radius: 4px;
}

.search-box ::v-deep .el-select .el-select__tags {
  max-width: 120px !important;
}

.search-box ::v-deep .el-select .el-tag {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 讲师列表 */
.lecturer-list {
  flex: 1;
  overflow-y: auto;
}

.lecturer-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid #f2f6fc;
}

.lecturer-item:hover {
  background: #f5f7fa;
}

.lecturer-item.active {
  background: #ecf5ff;
  border-left: 3px solid #409eff;
}

/* 编号 */
.lecturer-index {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  border-radius: 4px;
  font-size: 12px;
  color: #909399;
  margin-right: 12px;
  flex-shrink: 0;
}

/* 头像 */
.lecturer-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-text {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.avatar-img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.lecturer-info {
  flex: 1;
  min-width: 0;
}

.lecturer-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lecturer-position {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lecturer-categories {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.category-tag {
  height: 18px;
  line-height: 16px;
  padding: 0 4px;
  font-size: 10px;
}

.lecturer-type {
  flex-shrink: 0;
  margin-left: 8px;
}

/* 分页 */
.pagination-wrapper {
  padding: 8px 0;
  display: flex;
  justify-content: center;
  background: #fff;
}

.pagination-wrapper ::v-deep .el-pagination {
  font-weight: normal;
  font-size: 12px;
  width: 90%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li {
  background: #fff;
  border: none;
  border-radius: 4px;
  margin: 0 2px;
  font-weight: 500;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  transition: all 0.2s;
}

.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li:hover {
  background: #f0f4ff;
  color: #667eea;
}

.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):active {
  transform: scale(0.95);
}

.pagination-wrapper ::v-deep .btn-prev,
.pagination-wrapper ::v-deep .btn-next {
  border: none;
  background: transparent;
  transition: all 0.2s;
  padding: 0 6px;
  min-width: 24px;
  height: 24px;
  color: #909399;
}

.pagination-wrapper ::v-deep .btn-prev:hover,
.pagination-wrapper ::v-deep .btn-next:hover {
  color: #667eea;
  background: #f0f4ff;
}

.pagination-wrapper ::v-deep .el-pagination__total {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
  line-height: 24px;
}

.pagination-wrapper ::v-deep .el-pagination__sizes {
  margin-right: 8px;
}

.pagination-wrapper ::v-deep .el-input__inner {
  font-size: 12px;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.pagination-wrapper ::v-deep .el-select .el-input__suffix {
  height: 24px;
  line-height: 24px;
}

.pagination-wrapper ::v-deep .el-pagination__jump {
  margin-left: 8px;
  line-height: 24px;
}

.pagination-wrapper ::v-deep .el-pagination__jump .el-input__inner {
  width: 40px;
}

/* 右侧面板 */
.right-panel {
  flex: 1;
  background: #fff;
  overflow: hidden;
}

/* 滚动条 */
.lecturer-list::-webkit-scrollbar {
  width: 4px;
}

.lecturer-list::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 2px;
}

.lecturer-list::-webkit-scrollbar-track {
  background: #f5f7fa;
}
</style>
